import type { BodyMeasurementLogConfig, WidgetConfig } from "@/lib/schema";
import { getWidgetModule } from "@/widgets/registry";
import type { DayWidgetModule } from "@/widgets/types";
import { DayView } from "./DayView";
import { SettingsEditor } from "./SettingsEditor";
import { validate } from "./validate";

function defaults(existing: WidgetConfig[]): BodyMeasurementLogConfig {
  const dayWidgets = existing.filter(
    (w) => getWidgetModule(w.kind)?.scope === "day",
  );
  const maxRow = dayWidgets.reduce((m, w) => Math.max(m, w.row), -1);
  return {
    id: crypto.randomUUID(),
    kind: "body-measurement-log",
    label: "Kroppsmål",
    row: maxRow + 1,
    column: 0,
    enabled: true,
    types: ["weight", "abdomen"],
  };
}

export const bodyMeasurementLog: DayWidgetModule<BodyMeasurementLogConfig> = {
  kind: "body-measurement-log",
  label: "Kroppsmål",
  scope: "day",
  scoring: "none",
  defaults,
  validate,
  SettingsEditor,
  DayView,
};
